import React from 'react'
import './sectionCases.css'
import { FaChevronRight, FaClock } from 'react-icons/fa'

/* ──────────────────────────────────────────────────────
   Competências SAP exibidas no banner de destaque
────────────────────────────────────────────────────── */
const sapSkills = [
    'ABAP', 'SAP Fiori / UI5', 'BTP', 'SAP PI/PO',
    'MM', 'FI', 'HCM', 'BAPI / RFC', 'ALV Reports', 'User Exits',
]

/* ──────────────────────────────────────────────────────
   Cases de sucesso — dados baseados no portfólio real
────────────────────────────────────────────────────── */
const cases = [
    {
        cliente: 'Ourofino Saúde Animal',
        setor: 'Agronegócio',
        titulo: 'App Fiori — Gestão de Afastamentos Médicos',
        descricao:
            'Desenvolvimento de um aplicativo SAP Fiori (UI5) com BTP para digitalizar completamente o processo de gestão de afastamentos e atestados médicos. A solução substituiu processos manuais e formulários físicos, integrando workflow de aprovação diretamente ao módulo de RH.',
        destaques: [
            'Integração completa com workflows de aprovação',
            'Go-Live em 3 meses',
            'Processo 100% digital — zero formulários físicos',
        ],
        tags: ['SAP Fiori', 'UI5', 'BTP', 'HCM'],
        timeline: 'Go-Live em 3 meses',
    },
    {
        cliente: 'Ourofino Saúde Animal',
        setor: 'Agronegócio',
        titulo: 'App Fiori — Gestão Contábil de Documentos FI',
        descricao:
            'Solução desenvolvida em SAP Fiori (UI5) com BTP para simplificar o lançamento de documentos contábeis no módulo FI. O aplicativo oferece interface moderna e intuitiva, com validações em tempo real e controle total de status por documento.',
        destaques: [
            'Integração nativa com módulo FI do SAP',
            'Validações em tempo real com feedback visual',
            'Customização completa de acordo com processos internos',
        ],
        tags: ['SAP Fiori', 'UI5', 'BTP', 'FI'],
        timeline: 'Go-Live em 4 meses',
    },
    {
        cliente: 'Grupo Soufer',
        setor: 'Indústria / Papel',
        titulo: 'App Mobile — Baixa de Materiais integrado ao SAP MM',
        descricao:
            'Criação de aplicativo mobile em React Native integrado ao módulo MM do SAP, permitindo que operadores realizem baixa de materiais do estoque diretamente pelo celular — sem necessidade de acesso ao terminal SAP. Leitura de QR Code, validação em tempo real e registro automático no ERP.',
        destaques: [
            'Integração em tempo real com SAP MM via API',
            'Leitura de QR Code para identificação de materiais',
            'Rastreabilidade total dos lançamentos no SAP',
        ],
        tags: ['React Native', 'Node.js', 'SAP MM', 'REST API'],
        timeline: 'Go-Live em 2 meses',
    },
    {
        cliente: 'Setor de Energia / Utilities',
        setor: 'Energia',
        titulo: 'Adaptador de Integração entre Sistemas via SAP/PI',
        descricao:
            'Desenvolvimento de um adaptador avançado de protocolos para integração entre sistemas de medição e plataforma de faturamento, utilizando SAP/PI e protocolo SOAP assíncrono. O maior desafio foi garantir alta escalabilidade e confiabilidade das mensagens, superado com sistema de filas Redis e Node.js.',
        destaques: [
            'Arquitetura escalável com Redis e sistema de filas',
            'Integração SOAP assíncrona com SAP/PI',
            'Retentativas automáticas e logs detalhados de auditoria',
        ],
        tags: ['Node.js', 'Redis', 'SAP/PI', 'SOAP', 'REST'],
        timeline: 'Go-Live em 3 meses',
    },
]

export default function SectionCases() {
    return (
        <div id="cases" className="container-fluid">
            <div className="container">

                {/* Header da seção */}
                <div className="cases-header" data-aos="fade-up">
                    <label className="tituloSection d-flex justify-content-center">Cases de Sucesso</label>
                    <p className="subTituloSection mt-3">
                        Projetos reais,{' '}
                        <span style={{ color: 'var(--orange)' }}>resultados concretos</span>
                    </p>
                    <p className="textoSection mt-3" style={{ textAlign: 'center' }}>
                        Veja alguns dos projetos que desenvolvemos para empresas de diferentes setores —
                        sempre com arquitetura limpa, documentação completa e entrega dentro do prazo.
                    </p>
                </div>

                {/* ── Banner especial SAP ── */}
                <div className="sap-banner" data-aos="fade-up">
                    <div className="sap-banner-text">
                        <h3>Especialistas em Desenvolvimento SAP</h3>
                        <p>
                            Nosso maior portfólio é em SAP — desde customizações ABAP e aplicativos Fiori
                            até integrações complexas com PI/PO e BTP. Entregamos soluções robustas
                            que se encaixam perfeitamente nos processos já existentes da sua empresa.
                        </p>
                    </div>
                    <div className="sap-skills">
                        {sapSkills.map(s => (
                            <span key={s} className="sap-skill-pill">{s}</span>
                        ))}
                    </div>
                </div>

                {/* ── Grid de cases ── */}
                <div className="cases-grid">
                    {cases.map((c, i) => (
                        <div key={i} className="case-card" data-aos="fade-up">

                            {/* Cabeçalho do card */}
                            <div className="case-card-header">
                                <span className="case-client">{c.cliente}</span>
                                <span className="case-sector-tag">{c.setor}</span>
                            </div>

                            {/* Corpo */}
                            <div className="case-card-body">
                                <p className="case-title">{c.titulo}</p>
                                <p className="case-desc">{c.descricao}</p>

                                <ul className="case-highlights">
                                    {c.destaques.map((d, j) => (
                                        <li key={j}>
                                            <FaChevronRight className="case-chev" />
                                            {d}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Rodapé: tech tags + timeline */}
                            <div className="case-card-footer">
                                <div className="case-tech-tags">
                                    {c.tags.map(t => (
                                        <span key={t} className="case-tech-tag">{t}</span>
                                    ))}
                                </div>
                                <span className="case-timeline">
                                    <span className="case-timeline-dot" />
                                    <FaClock style={{ fontSize: 10 }} />
                                    {c.timeline}
                                </span>
                            </div>

                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}
